import type { ProductVariantWithStock } from '@/app/api/products/[sku]/types';
import type { ProductVariant } from '@/types/Product';

/**
 * Whether a variant is in stock. Availability is optional at the UI boundary:
 * variants from the getProducts endpoint carry `inStock`
 * (ProductVariantWithStock) while plain ones don't — absence counts as in
 * stock, matching the API's fail-open stance.
 */
const isVariantInStock = (
  variant: ProductVariant | null | undefined,
): boolean =>
  (variant as Partial<ProductVariantWithStock> | null | undefined)?.inStock !==
  false;

export default isVariantInStock;
